import { Form, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Cron } from "react-js-cron";

export default function ({ field, form, disabled }) {
  const cronValue = form.getFieldValue([field.name, "cron", "value"]) || '* * * * *';

  const handleChange = (newValue) => {
    const crons = form.getFieldValue("crons") || [];
    crons[field.name].firstRun = undefined;
    crons[field.name].cron = {
      value: newValue,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    form.setFieldsValue({ crons });
  };

  return (
    <Form.Item
      name={[field.name, "cron", "value"]}
      label={
        <span>
          Cron Expression{" "}
          <Tooltip title="Define the cron schedule (e.g., every hour, daily at noon, etc.)">
            <InfoCircleOutlined style={{ color: "#1890ff" }} />
          </Tooltip>
        </span>
      }
      rules={[{ required: true, message: "Please select a valid cron expression" }]}
    >
      <Cron
        value={cronValue}
        setValue={handleChange}
        clearButton={false}
        disabled={disabled}
      />
    </Form.Item>
  );
};
